import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the menu editor a "Menus" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/content/menus')({
  staticData: { crumb: 'common:nav.menus' },
  component: Outlet,
});
